import {List} from 'immutable';
import {uniq} from 'lodash';
import {updateIn} from '@packages/systems/core/utils/ImmUtils';
import {getIdWithoutInstance} from '@packages/systems/core/utils/NativeIdUtils';
import {
  ACTION_ITEM_PREFIX,
  ACTION_PREFIX,
  EVENT_PREFIX,
  INTERACTION_PREFIX,
  PARAMETER_GROUP_PREFIX,
} from '@packages/systems/ix2/designer/constants';
import {IX2EngineConstants} from '@packages/systems/ix2/shared-constants';
import {
  IX2ActionItemType,
  IX2ActionList,
  IX2EventList,
  IX2Interactions,
  IX2ItemTypes,
} from '@packages/systems/ix2/types-core';
import {increment} from '@packages/utilities/string-utils';
const {IX2_ID_DELIMITER} = IX2EngineConstants;

export const hasPageId = (targetId: string) =>
  targetId && targetId.includes(IX2_ID_DELIMITER);

export const getNodeIdFromIx2Id = (targetId: string) =>
  getIdWithoutInstance(
    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    hasPageId(targetId) ? targetId.split(IX2_ID_DELIMITER)[1] : targetId
  );
export const setNodeIdFromIx2Id = (pageId: string, targetId: string) =>
  pageId.concat('|', targetId);

export const getInteractionsByTargetId =
  (interactions: IX2Interactions) =>
  (targetId: string): IX2Interactions =>
    interactions.filter(({target}) => {
      return target === targetId;
    }) as IX2Interactions;

export const updateInteractionEventIds = (newId: string) =>
  // @ts-expect-error - TS7006 - Parameter 'eventIds' implicitly has an 'any' type.
  updateIn((eventIds) => (eventIds || []).concat(newId))(['eventIds']);

export const findIndexById =
  (list: List<IX2ActionItemType>) => (searchId: string) =>
    list.findIndex(({id}) => id === searchId);

export const prependPageId = (pageId: string, targetId: string) =>
  `${pageId}${IX2_ID_DELIMITER}${targetId}`;

export const hasPageIdInTarget =
  (pageId?: string | null) => (targetId: string) =>
    (hasPageId(targetId) && getPageIdFromIx2Id(targetId) === pageId) ||
    pageId === targetId;

export const getPageIdFromIx2Id = (targetId: string) =>
  hasPageId(targetId) ? targetId.split(IX2_ID_DELIMITER)[0] : targetId;

// @ts-expect-error - TS7006 - Parameter 'newPageId' implicitly has an 'any' type. | TS7006 - Parameter 'targetId' implicitly has an 'any' type.
export const replacePageId = (newPageId) => (targetId) =>
  hasPageId(targetId)
    ? `${newPageId}|${targetId.split(IX2_ID_DELIMITER)[1]}`
    : prependPageId(newPageId, targetId);

export const replaceNodeId = (newTargetId: string) => (oldTargetId: string) =>
  hasPageId(oldTargetId)
    ? `${getPageIdFromIx2Id(oldTargetId)}|${getIdWithoutInstance(newTargetId)}`
    : getIdWithoutInstance(newTargetId);

export const replaceActionItemTargetNodeId =
  (newTargetId: string) => (oldTargetId: string) => ({
    id: hasPageId(oldTargetId)
      ? `${getPageIdFromIx2Id(oldTargetId)}|${getIdWithoutInstance(
          newTargetId
        )}`
      : getIdWithoutInstance(newTargetId),
  });

export const getUniqueEventId = (events: IX2EventList): string =>
  getUniqueId(EVENT_PREFIX, events);

export const getUniqueInteractionId = (interactions: IX2Interactions): string =>
  getUniqueId(INTERACTION_PREFIX, interactions);

export const getUniqueActionListId = (actionLists: IX2ActionList): string =>
  getUniqueId(ACTION_PREFIX, actionLists);

export const getUniqueId = (
  prefix: string | null | undefined = '',
  collection: List<IX2ItemTypes>
): string => {
  const prefixes = collection.reduce<Array<any>>(
    (result: Array<string>, value: any) => {
      return result.concat([value.id]);
    },
    []
  );
  // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
  return increment(uniq(prefixes), prefix, '-');
};

export const getUniqueParameterGroupId = (
  actionList: IX2ActionList,
  groups: IX2ItemTypes
  // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'IX2ActionList'. | TS2345 - Argument of type 'IX2ItemTypes' is not assignable to parameter of type 'List<IX2ItemTypes>'.
): string => getUniqueId(`${actionList.id}-${PARAMETER_GROUP_PREFIX}`, groups);

export const getUniqueActionItemId = (
  actionList: IX2ActionList,
  actionItems: List<IX2ItemTypes>
  // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'IX2ActionList'.
): string => getUniqueId(`${actionList.id}-${ACTION_ITEM_PREFIX}`, actionItems);
